import React from "react";
import { interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { SPRING_CONFIGS } from "../utils/springs";
import { loadFont } from "@remotion/google-fonts/Inter";

const { fontFamily } = loadFont();

type FadeInTextProps = {
  children: React.ReactNode;
  delay?: number;
  fontSize?: number;
  fontWeight?: number;
  color?: string;
  slideDistance?: number;
  style?: React.CSSProperties;
};

export const FadeInText: React.FC<FadeInTextProps> = ({
  children,
  delay = 0,
  fontSize = 48,
  fontWeight = 600,
  color = "#FFFFFF",
  slideDistance = 30,
  style,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const progress = spring({
    frame,
    fps,
    delay,
    config: SPRING_CONFIGS.smooth,
  });

  const opacity = interpolate(progress, [0, 1], [0, 1]);
  const translateY = interpolate(progress, [0, 1], [slideDistance, 0]);

  return (
    <div
      style={{
        fontFamily,
        fontSize,
        fontWeight,
        color,
        opacity,
        transform: `translateY(${translateY}px)`,
        ...style,
      }}
    >
      {children}
    </div>
  );
};
